import { render, staticRenderFns } from "./Section5thIm.vue?vue&type=template&id=fc6d6cc0&scoped=true&"
import script from "./Section5thIm.vue?vue&type=script&lang=js&"
export * from "./Section5thIm.vue?vue&type=script&lang=js&"
import style0 from "./Section5thIm.vue?vue&type=style&index=0&id=fc6d6cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6d6cc0",
  null
  
)

export default component.exports